import React from "react";

import { AdminSideNavBarBody } from "@src/components/Navigation/AdminSideNav/AdminSideNavBarBody";
import { NavigationDrawer } from "@src/components/Navigation/BaseSideNav/NavigationDrawer";
import { useSelector } from "@src/store";

export const AdminSideNav = () => {
  const sideNavCollapsed = useSelector(
    (state) => state.appSettings.sideNavCollapsed
  );

  return (
    <NavigationDrawer
      isUnauthorized={false}
      hideOrgPicker={true}
      customBody={<AdminSideNavBarBody drawerOpen={!sideNavCollapsed} />}
      customFooter={null}
    />
  );
};
